import { render } from "./Purchase.vue?vue&type=template&id=00814912&ts=true"
import script from "./Purchase.vue?vue&type=script&lang=ts"
export * from "./Purchase.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__